class ACProductGrouping {
  #products = [];
  #current  = {};
  #container;

  static CATEGORY_ICONS = {
    'Hoodie': '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8c-4 1-8 4-9 8l5 2.5V34h16V18.5l5-2.5c-1-4-5-7-9-8"/><path d="M16 8c1 3 2.5 5 4 5s3-2 4-5"/><path d="M13 4c1.5 2.5 3.5 4 7 4s5.5-1.5 7-4H13z"/></svg>',
    'T-Shirt': '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 7L5 12l4 7 5-2.5V34h12V16.5l5 2.5 4-7-10-5c-1 2.5-3 4-5 4s-4-1.5-5-4z"/></svg>',
    'Sweatshirt': '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 7L5 12l4 7 5-2.5V34h12V16.5l5 2.5 4-7-10-5c-1 2.5-3 4-5 4s-4-1.5-5-4z"/><path d="M8 28h24"/></svg>',
    'Long Sleeve': '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 7L4 11l2 17 7 1V34h14V29l7-1 2-17-11-4c-1 2.5-3 4-5 4s-4-1.5-5-4z"/></svg>',
    'Tank Top': '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 6c0 3.5 1.5 6 4 6s4-2.5 4-6"/><path d="M16 6C14 8 11 10 9 11V34h22V11c-2-1-5-3-7-5"/></svg>',
  };

  #iconMap = {};

  constructor(container) {
    this.#container = container;
    this.#products  = this.#parseProducts();
    this.#iconMap   = this.#parseIcons();
    this.#current   = {
      gender:      container.dataset.currentGender     || null,
      category:    container.dataset.currentCategory   || null,
      option:      container.dataset.currentOption     || null,
      color_group: container.dataset.currentColorGroup || null,
    };
    // Normalize empty strings to null
    for (const k of Object.keys(this.#current)) {
      if (this.#current[k] === '') this.#current[k] = null;
    }
    this.#render();
  }

  #parseIcons() {
    const el = document.getElementById('ac-category-icons');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch { return {}; }
  }

  #parseProducts() {
    const el = document.getElementById('ac-design-products');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[AC Grouping] Failed to parse product data', e);
      return [];
    }
  }

  static GENDER_ORDER   = ["Men's", "Women's", 'Children'];
  static CATEGORY_ORDER = ['T-Shirt', 'Tank Top', 'Long Sleeve', 'Sweatshirt', 'Hoodie'];
  static OPTION_ORDER   = [
    'Classic', 'Oversized', 'Premium', 'High Waisted',
    'Baby', 'Toddler', 'Kids', 'Youth',
    'Basketball', 'Sleeveless Tee', 'Micro-Rib', 'Racerback',
    'Hooded', 'Rash Guard', 'Crop Top',
    'Organic', 'Comfort', 'Eco',
    'Zipper', 'Under Armour', 'Cropped',
  ];

  #unique(arr, order = []) {
    const vals = [...new Set(arr.filter(v => v != null && v !== ''))];
    if (!order.length) return vals;
    return vals.sort((a, b) => {
      const ai = order.indexOf(a);
      const bi = order.indexOf(b);
      if (ai === -1 && bi === -1) return a.localeCompare(b);
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }

  #filter(criteria) {
    return this.#products.filter(p =>
      Object.entries(criteria).every(([k, v]) => p[k] === v)
    );
  }

  // Navigate to the best matching product, relaxing constraints from most to least specific
  #navigate(gender, category, option, color_group) {
    const tests = [
      p => p.gender === gender && p.category === category && p.option === option && p.color_group === color_group,
      p => p.gender === gender && p.category === category && p.option === option && !p.color_group,
      p => p.gender === gender && p.category === category && p.option === option,
      p => p.gender === gender && p.category === category,
      p => p.gender === gender,
    ];
    for (const test of tests) {
      const match = this.#products.find(test);
      if (match) { window.location.href = match.url; return; }
    }
  }

  #icon(category) {
    const entry = this.#iconMap[category];
    if (entry) {
      const defaultUrl = entry.default;
      const activeUrl  = entry.active;
      if (defaultUrl && activeUrl) {
        return `<img class="ac-icon--default" src="${defaultUrl}" alt="${category}"><img class="ac-icon--active" src="${activeUrl}" alt="${category}">`;
      }
      if (defaultUrl) return `<img src="${defaultUrl}" alt="${category}">`;
    }
    return ACProductGrouping.CATEGORY_ICONS[category]
      || ACProductGrouping.CATEGORY_ICONS['T-Shirt'];
  }

  #renderSection(sectionId, items, current, withIcons, minCount, onClick) {
    const section = document.getElementById(sectionId);
    if (!section) return;
    if (items.length < minCount) { section.style.display = 'none'; section.innerHTML = ''; return; }

    const wrap = document.createElement('div');
    wrap.className = `ac-group__btns${withIcons ? ' ac-group__btns--icons' : ''}`;

    items.forEach(item => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `ac-btn${item === current ? ' ac-btn--active' : ''}${withIcons ? ' ac-btn--icon' : ''}`;
      if (withIcons) {
        btn.innerHTML = this.#icon(item);
        btn.setAttribute('aria-label', item);
        btn.title = item;
      } else {
        btn.textContent = item;
      }
      btn.addEventListener('click', () => { if (item !== current) onClick(item); });
      wrap.appendChild(btn);
    });

    section.innerHTML = '';
    section.appendChild(wrap);
    section.style.display = '';
  }

  #render() {
    const { gender, category, option, color_group } = this.#current;

    // Gender — hide if only 1
    const genders = this.#unique(this.#products.map(p => p.gender), ACProductGrouping.GENDER_ORDER);
    this.#renderSection('ac-gender-section', genders, gender, false, 2, g => {
      this.#navigate(g, category, option, color_group);
    });

    // Category — hide if only 1 for this gender
    const categories = this.#unique(this.#filter({ gender }).map(p => p.category), ACProductGrouping.CATEGORY_ORDER);
    this.#renderSection('ac-category-section', categories, category, true, 2, c => {
      this.#navigate(gender, c, option, null);
    });

    // Option — hide if only 1 for this gender + category
    const options = this.#unique(this.#filter({ gender, category }).map(p => p.option), ACProductGrouping.OPTION_ORDER);
    this.#renderSection('ac-option-section', options, option, false, 2, o => {
      this.#navigate(gender, category, o, null);
    });

    // Color group — show if any color-group products exist for this gender + category + option
    const colorGroups = this.#unique(
      this.#filter({ gender, category, option }).map(p => p.color_group).filter(Boolean)
    );
    this.#renderSection('ac-color-group-section', colorGroups, color_group, false, 1, cg => {
      this.#navigate(gender, category, option, cg);
    });
  }
}

const acEl = document.getElementById('ac-product-grouping');
if (acEl) new ACProductGrouping(acEl);
